module.exports = __webpack_public_path__ + "img/landingpage-video-tablet.2b2ec271.svg";